<template>
  <div class="mc-table">
    <div v-if="!noHeader" class="mc-table-header flex-box justify-space-between">
      <div v-for="(col, index) in columns" :key="index" :style="computedWidth(col)" class="mc-table-header-cell">
        {{ col.label }}
        <span class="secondary-text">{{ col.label_desc }}</span>
      </div>
    </div>
    <div class="mc-table-body" v-if="data.length">
      <div
        v-for="(row, rowIndex) in data"
        :key="rowIndex"
        class="mc-table-row flex-box justify-space-between align-items-center"
      >
        <div v-for="(col, colIndex) in columns" :key="colIndex" :style="computedWidth(col)" class="mc-table-cell">
          <slot :name="col.prop" :row="row" :col="col" :$index="rowIndex">
            <!-- 默认内容，如果没有提供插槽 -->
            {{ row[col.prop] }}
          </slot>
        </div>
      </div>
    </div>
    <div class="mc-table-body" v-else><el-empty :image-size="200"></el-empty></div>
  </div>
</template>

<script>
export default {
  name: "McTable",
  props: {
    data: {
      type: Array,
      required: true,
    },
    /**
     * 表格列配置数组。
     * @type {Array<{label: string, prop: string, label_desc?: string, width?: string}>}
     *
     * @property {string} label        - 列标题显示文本
     * @property {string} prop         - 对应 data 行数据的字段 key，也用作具名插槽名称
     * @property {string} [label_desc] - 列标题的次要说明（显示在标题后，带 secondary-text 样式）
     * @property {string} [width]      - 列宽度 CSS 值，如 "200px"、"30%"；不传则 flex: 1 均分剩余空间
     *
     * @example
     * // 基本用法
     * columns: [
     *   { label: '名称', prop: 'name', width: '200px' },
     *   { label: '描述', prop: 'desc', label_desc: '(副标题)' },
     *   { label: '操作', prop: 'actions' },
     * ]
     */
    columns: {
      type: Array,
      required: true,
    },
    noHeader: {
      default: false,
    },
  },
  methods: {
    computedWidth({ width }) {
      return {
        flex: width ? `0 0 ${width}` : 1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.mc-table {
  width: 100%;
  .mc-table-header {
    margin-bottom: 12px;
    padding: 0 20px;
    .mc-table-header-cell {
      font-weight: 400;
      font-size: 16px;
      color: var(--mc-info-text-color);
      line-height: 22px;
      text-align: left;
      font-style: normal;
    }
  }

  .mc-table-body {
    .mc-table-row {
      background: var(--mc-background-main-color);
      border-radius: 24px;
      margin-bottom: 12px;
      padding: 20px;
      .mc-table-cell {
        // padding-left: 20px;
      }
    }
  }

  &.border-list {
    .mc-table-body {
      .mc-table-row {
        border-radius: var(--mc-border-radius-normal);
        border: 1px solid var(--mc-border-color);
      }
    }
  }

  &.small {
    .mc-table-header {
      padding: 12px;
      margin-bottom: 0;
      .mc-table-header-cell {
        font-size: 14px;
      }
    }
    .mc-table-body {
      .mc-table-row {
        padding: 12px;
      }
    }
  }
}
</style>
